import { render, staticRenderFns } from "./sister-shops.vue?vue&type=template&id=3df5efe2"
import script from "./sister-shops.vue?vue&type=script&lang=ts"
export * from "./sister-shops.vue?vue&type=script&lang=ts"
import style0 from "./sister-shops.vue?vue&type=style&index=0&id=3df5efe2&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3df5efe2')) {
      api.createRecord('3df5efe2', component.options)
    } else {
      api.reload('3df5efe2', component.options)
    }
    module.hot.accept("./sister-shops.vue?vue&type=template&id=3df5efe2", function () {
      api.rerender('3df5efe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/sister-shops.vue"
export default component.exports